module.exports = __webpack_public_path__ + "assets/img/teacher (11).535a5dc2.png";